export const INIT_USER_SETTINGS = "INIT_USER_SETTINGS";
